module.exports = __webpack_public_path__ + "static/media/amity_logo.5f4c3afc.png";